import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2a87372"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop" }, null, -1))
const _hoisted_2 = { class: "ReportPage" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Generar Reporte", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "row w-100" }
const _hoisted_6 = { class: "col-9" }
const _hoisted_7 = {
  class: "row g-3 needs-validation",
  novalidate: ""
}
const _hoisted_8 = { class: "row mb-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label col-form-label-sm" }, "Fecha Desde", -1))
const _hoisted_10 = { class: "col-sm-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label col-form-label-sm" }, "Fecha Hasta", -1))
const _hoisted_12 = { class: "col-sm-4" }
const _hoisted_13 = { class: "row mb-1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label col-form-label-sm" }, "Transac.", -1))
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = { selected: "" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "row mb-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label col-form-label-sm" }, "Cliente", -1))
const _hoisted_20 = { class: "col-sm-7" }
const _hoisted_21 = { selected: "" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "row mb-1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label col-form-label-sm" }, "Documento", -1))
const _hoisted_25 = { class: "col-sm-4" }
const _hoisted_26 = { class: "row mb-1" }
const _hoisted_27 = { class: "col-sm-4" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Estado", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "I" }, "Ingresadas", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "C" }, "Calculada", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "E" }, "Entregadas", -1))
const _hoisted_32 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]

import { computed, PropType, ref, onMounted } from 'vue';
import axios from 'axios';
import { useDateTimeStore } from '@/store/dateTimeStore';
import { UrlGlobal } from '@/store/dominioGlobal';
import { useAlert } from '@/store/useAlert';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExCuartoFrio',
  props: {
  btnEx: Boolean

},
  emits: ['insertProps'],
  setup(__props, { emit: __emit }) {

const { error, success } = useAlert()
const dUrl = UrlGlobal()
const dateTimeStore = useDateTimeStore();

const props = __props

const emits = __emit
const handleClick = () => {
  emits("insertProps", !props.btnEx)
}

const fecha_desde = ref<string>('')
const fecha_hasta = ref<string>('')
const codigo = ref<string>('')
const cliente = ref<string>('')
const documento = ref<string>('')
const status = ref<string>('')
//const matricula_aeronave = computed(() => `${props.fecha} ${props.matricula}`);

const envio_data = computed(() => ({
  fecha_desde: fecha_desde.value,
  fecha_hasta: fecha_hasta.value,
  codigo: codigo.value,
  cliente: cliente.value,
  documento: documento.value,
  status: status.value
}));

// Método para generar el Excel
const generateExcel = async () => {
  if (!fecha_desde.value) {
    error('Debe digitar la fecha inicial...')
    return
  }
  if (!fecha_hasta.value) {
    error('Debe digitar la fecha final...')
    return
  }

  if (fecha_desde.value > fecha_hasta.value) {
    error('Fecha inicial no puede ser mayor que la fecha final...')
    return
  }

  try {
    const response = await axios.post(
      dUrl.urlGlobal + '/api2/Logctmo_excel',
      envio_data.value,
      { responseType: 'blob' }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'movimientos_ctofrio.xlsx');
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error al generar el manifiesto:', error);
  }
};

const codigos = ref<any[]>([]);
const clientes = ref<any[]>([])
onMounted(async () => {
  const responseN = await axios.get(dUrl.urlGlobal + '/api2/logtral/filter?status=A')
  codigos.value = responseN.data

  const responseC = await axios.get(dUrl.urlGlobal + '/api2/crmclte/filter?status=A')
  clientes.value = responseC.data
})
//computados de las ayudas
const descripcionCodigo = computed(() => {
  const encontrado = codigos.value.find(op => op.codigo === codigo.value)
  return encontrado ? encontrado.descripcion : ''
})

const descripcionCliente = computed(() => {
  const encontrado = clientes.value.find(op => op.cliente === cliente.value)
  return encontrado ? encontrado.nombre_comercial : ''
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("form", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fecha_desde).value = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, fecha_desde.value]
                ])
              ]),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fecha_hasta).value = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, fecha_hasta.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((codigo).value = $event))
                }, [
                  _createElementVNode("option", _hoisted_16, _toDisplayString(descripcionCodigo.value), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codigos.value, (op) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: op.codigo,
                      value: op.codigo
                    }, _toDisplayString(op.descripcion), 9, _hoisted_17))
                  }), 128))
                ], 512), [
                  [_vModelSelect, codigo.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cliente).value = $event))
                }, [
                  _createElementVNode("option", _hoisted_21, _toDisplayString(descripcionCliente.value), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientes.value, (op) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: op.cliente,
                      value: op.cliente
                    }, _toDisplayString(op.nombre_comercial), 9, _hoisted_22))
                  }), 128))
                ], 512), [
                  [_vModelSelect, cliente.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((documento).value = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, documento.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((status).value = $event))
                }, _hoisted_32, 512), [
                  [_vModelSelect, status.value]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", { class: "col-3 d-flex align-items-start justify-content-end" }, [
          _createElementVNode("div", { style: {"width":"200px","background-color":"rgba(255,255,255,0.3)","backdrop-filter":"blur(10px)","border-radius":"10px","padding":"15px","display":"flex","flex-direction":"column","gap":"10px","overflow":"hidden"} }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              onClick: generateExcel
            }, " Generar Excel "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              onClick: handleClick
            }, " Cancelar ")
          ])
        ])
      ])
    ])
  ], 64))
}
}

})